import reducer, { initialState } from './reducer'
import * as selectors from './selectors'
import * as actions from './actions'

export default reducer

export { actions, reducer, selectors, initialState }
